import { StockValuationReportLine } from "./line";


export class StockValuationReportToggleLine extends StockValuationReportLine {
    static template = "stock_account.StockValuationReport.InventoryValuationToggleLine";
}

StockValuationReportToggleLine.components.StockValuationReportToggleLine = StockValuationReportToggleLine;